<template>
  <div class="landing-manual">
    <div class="section__title">
      <div class="logo slow" v-inview:animate="'fadeIn'">
        <img src="@/assets/images/logo-logo-fundanow-bb.svg" alt="로고"/>
        <p style="font-size: 10px; font-weight: 500;"> 대한민국 1등 자영업자 전문 금융 플랫폼 </p>
      </div>
      <p class="page-title">📜펀다나우 사용 설명서</p>
    </div>
    <div class="section__manual">
      <v-collapse-group>
        <!-- @onStatusChange="collapse" -->
        <v-collapse-wrapper>
          <div v-collapse-toggle>
            <span>펀다나우는 어떤 서비스 인가요?</span>
            <img src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down"/>
          </div>
          <div v-collapse-content>
            펀다 나우는 상점에서 발생하는 카드 및 배달의 민족 매출을 분석하여 한도를 산출합니다.<br /><br />
            이용하는 방법은 경남은행 비대면 통장 개설 후 상점에서 발생하는 카드 및 배달의 민족 매출 입금 계좌를 경남은행으로 변경하는 조건으로 진행되며,
            경남은행으로 매출이 입금 되면 펀다가 100% 출금하여 25%는 대출 원리금으로 상환되고, 나머지 75%는 고객님께서 지정한 계좌로 자동 반환 됩니다.<br /><br />
            상점에서 발생하는 매출이 매일 다르기 때문에 한도는 매일 재 산출 되는 방식이며,
            이용 중 한도가 올랐을 경우 차액을 추가로 신청하여 이용하실 수 있습니다.
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper>
          <div v-collapse-toggle>
            <span>펀다나우의 대출 방식이 궁금해요</span>
            <img src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down"/>
          </div>
          <div v-collapse-content>
            펀다는 금융위로부터 허가받은 제도권 금융으로써 온라인투자연계금융업 에 등록 된 금융 기관 입니다.<br />
            투자자들의 투자금을 모집받아 송금하는 방식으로, 대출 신청 및 투자 모집 상황에 따라 신청 금액의 100% 가 모집 되지 않을 수 있으며,<br />
            이 경우 추가 한도가 발생 할 때마다 여러번에 나누어 신청과 지급 받기를 추천드립니다.<br /><br />
            대출 신청 시 다음날 오전 10시 투자 마감되어, 모집 금액 확인 후 계약서 작성 시 순차 송금이 진행되며 오후 4시까지 계약서가 작성되지 않는 경우 모집 된 금액은 자동 취소 됩니다.
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper>
          <div v-collapse-toggle>
            <span>경남은행 계좌 개설 방법</span>
            <img src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down"/>
          </div>
          <div v-collapse-content>
              휴대폰 어플 다운 받는 곳에서 경남은행을 검색하면 BNK 경남은행 어플이 있는데요, 어플을 다운 받아 간편하게 비대면으로 계좌 개설이 가능합니다.
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper>
          <div v-collapse-toggle>
            <span>경남은행 통장 사본 저장하는 방법</span>
            <img src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down"/>
          </div>
          <div v-collapse-content v-inview:animate="'fadeIn'">
            <img src="@/assets/images/landing/manual/bank_save_image.jpg" alt="bank_save_image" class="bank-save-image"/>
          </div>
        </v-collapse-wrapper>
        <v-collapse-wrapper>
          <div v-collapse-toggle>
            <span>서비스 신청 방법 (경남은행 계좌 개설 완료 후 )</span>
            <img src="@/assets/images/agreements/arrow-down.svg" alt="arrow-down"/>
          </div>
          <div v-collapse-content>
            1.펀다나우 로그인<br /><br />
            2.나의정보 -> 개설한 경남은행 계좌번호 입력 후 ARS 인증<br /><br />
            3.대출금 입금 및 매출 환급계좌 입력 후 계좌 1원 인증<br /><br />
            ( 예금주명이 고객님 이름 세글자가 아닌, 이름 + 상호명으로 된 계좌 일 경우 등록이 불가 합니다. )<br /><br />
            4.서류 제출하기를 클릭하여 신분증, 사업자등록증, 경남은행 통장 사본, 최근 3개월 이내 발급한 2020년도분 소득금액증명원 업로드까지 완료하면 담당 부서에서 순차적으로 연락 드리겠습니다.
          </div>
        </v-collapse-wrapper>
      </v-collapse-group>
    </div>
    <div class="section__carousel">
      <div class="section__carousel__wrapper">
        <v-carousel
          cycle
          :interval="3000"
          :show-arrows="false"
          height="200"
        >
          <v-carousel-item
            v-for="(borrower, i) in borrowers"
            :key="i"
          >
            <v-card
              color="white"
              height="100%"
            >
            <div class="d-flex flex-no-wrap aligns-center justify-space-between">
              <v-avatar
                class="ma-3"
                size="70"
                tile
              >
                <v-img
                  :src="
                    require('@/assets/images/landing/' + borrower.imageName)
                  "></v-img>
              </v-avatar>
              <v-card-title v-html="borrower.name"></v-card-title>
            </div>
            <div>
                <v-card-text>{{ borrower.content }}</v-card-text>
            </div>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
    <div class="section__total-loan">
      <p>펀다나우 누적 대출액</p>
      <p><ICountUp :endVal="3148" :delay="500"/>억 <ICountUp :endVal="6843" :delay="500"/>만원</p>
    </div>
    <div class="section__footer">
      <div class="section__footer__wrapper">
        <button
          type="button"
          @click="signinKakao"
          v-inview:animate="'fadeInUp'"
          >
          <div>
              <img src="@/assets/images/kakao_symbol.svg" />
              내 상점 한도 확인하기
          </div>
          </button>
      </div>
    </div>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import ChannelService from '@/service/channeltalk/ChannelService'

export default {
  data() {
    return {
      slider: {
        value: 10,
        min: 500,
        max: 3300,
      },
      borrowers: [
        {
          name: '일식 14년차 사장님',
          imageName: 'avatar1.png',
          content: `오늘 말일이라 조금이라도 큰 도움이 되네요. 고맙습니다. 정말감사드립니다. 펀다님 덕분에 고비 잘넘겼어요 어제 밤에 잠을 설치기는 했지만. 
          주말에 입금해주시고 고맙게 잘쓰고 장사 열심히해서 잘갚겠어요. 감사합니다`,
        },
        {
          name: '한식 4년차 사장님',
          imageName: 'avatar2.png',
          content: '펀다 비록 대출이지만 너무 감사드립니다! 우리 소상공인들 받쳐주는 튼실한 기업으로 번창하길 바래요..!!',
        },
        {
          name: '카페 3년차 사장님',
          imageName: 'avatar2.png',
          content: '힘들 때 잘쓰고 있으니 감사해요.',
        },
        {
          name: '중식 2년차 사장님',
          imageName: 'avatar3.png',
          content: '이번주 매출이 조금 늘어서 인지 한도도 급 상승하고 모집도 금방끝나서 모집 시작한지 1시간만에 완료되었네요 힘이들때 큰도움이 되서 정말감사합니다.',
        },
        {
          name: '분식 3년차 사장님',
          imageName: 'avatar3.png',
          content: '한도발생확인하고자 들어왔더니 한도금액보고깜놀했어요 안그래도 부가세걱정에인건비에걱정했는데 펀다분들께넘넘감사또감사드립니다 열심히벌어잘갚아나가겠습니다  감사합니다♡♡♡',
        },
      ],

    }
  },
  async created() {
    ChannelService.boot()

    // Check Code
    try {
      // Code Signin
      let code = this.$route.query.code
      if (code) {
        if (code === localStorage.getItem('kakaocode')) {
          return
        }
      } else {
        return
      }
      let res = await AuthService.signinCode(code) // 코드 로그인
      if (!res) return
      await this.signin() // 로그인 성공
    } catch (e) {
      // Token Signin
      setTimeout(_ => {
        this.signinKakaoToken()
      }, 500) // 토큰 로그인
    }
  },
  methods: {
    // Token
    async signinKakaoToken() {
      let res = await AuthService.getKakaoToken()
      if (!this._.get(res, 'access_token')) {
        return
      }
      await AuthService.signinKakaoToken(res.access_token)
      this.signin() // 로그인 성공
    },
    // Code
    async signinKakaoCode() {
      await AuthService.getKakaoCode()
    },
    async signinKakao() {
      try {
        this.signinKakaoCode() // 코드 로그인
      } catch (e) {
        this.signinKakaoToken() // 토큰 로그인
      } finally {
        // UTM
        await AuthService.sendUtmCookies()
      }
    },
    async signin() {
      await AuthService.syncProfile()
      ChannelService.boot()
      // Redirect Uri
      let redirectUri = this.$route.query.redirectUri
      if (redirectUri == null) {
        await this.$router.push({ name: 'dashboard' })
      } else {
        await this.$router.push({ path: redirectUri })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.landing-manual {
  background-color: white;
  background-image: url('../../assets/images/main/bg-fundanow-cash-cut@2x.png');
  background-color: #edeff2;
  background-size: auto;
  min-height: 100vh;
  padding-bottom: 100px;

  .section__title {
    padding: 30px 20px;
    .logo {
      text-align: center;
      margin-bottom: 20px;
    }
    .page-title {
      font-weight: 900;
      text-align: center;
      font-size: 20px;
    }
  }
  .section__manual {
    padding: 15px;

    .v-collapse-toggler {
      width: 100%;
      position: relative;
      z-index: 1;
      font-weight: 700;
      padding: 12px 12px;
      font-size: 16px;
      border-radius: 4px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      background-color: #e3ecf6;
      color: #333333;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
    .v-collapse-content.v-collapse-content-end {
      width: 100%;
      padding: 12px 12px 12px;
      line-height: 1.5rem;
      border-radius: 4px;
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
      background-color: white;
      margin-top: -15px;
      margin-bottom: 10px;

      .bank-save-image {
        width: 100%;
      }
    }
  }
  .section__carousel {
    padding: 15px;

    .v-carousel::v-deep {
      box-shadow: 0 12px 24px 0 rgba(51, 51, 51, 0.12);

      .v-card {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 15px;
        background-color: #ffffff;

        >div {
          align-items: center;
        }

        .v-avatar {
          @media screen and (max-width: 680px) {
            height: 55px !important;
            min-width: 55px !important;
            width: 55px !important;
          }
        }

        &__title {
          font-size: 16px;
          line-height: 1.5;
          font-weight: 600;
        }
        &__text {
          padding-bottom: 0;
          padding-left: 0;
          padding-right: 0;
        }
        &__title, &__text {
          color: #333333 !important;
        }
        @media screen and (max-width: 680px) {
          height: 300px !important;

          &__title {
            font-size: 14px;
          }
        }
      }

      .v-carousel__controls {
        background: transparent;

        .v-btn {
          height: 6px;
          width: 6px;

          &--active {
            background-color: #727d8c;
          }
        }

        .v-icon {
          font-size: 6px !important;
          color: #e1e9f3;
        }
      }
      @media screen and (max-width: 680px) {
        height: 300px !important;

        .v-carousel__item {
          height: 300px !important;
        }
      }
    }
  }
  .section__total-loan {
    text-align: center;
    margin: 40px 0 60px;
    line-height: 2rem;
    font-weight: 900;
    p:nth-child(1) {
      font-size: 18px;
    }
    p:nth-child(2) {
      font-size: 24px;
    }
  }
  .section__footer {
    margin-bottom: 10px;
    position: fixed;
    z-index: 2;
    bottom: 0;
    width: 100%;
    &__wrapper {
      padding: 20px;
      text-align: center;
    }
    button {
      margin: 0 auto;
      width: 100%;
      max-width: 400px;
      height: 64px;
      padding: 15px 15px;
      border-radius: 6px;
      font-size: 18px;
      font-weight: 900;
      box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);
      background-color: #ffe500;
      color: #252525;

      div {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 20px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
